export default __webpack_public_path__ + "static/media/yusd.1aa609a6.png";